import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { PersonalJourneyExplainations } from '../../components/JH/PersonalJourneyExplainations';
import { showDialog } from '../../redux/actions/MainDialog';
import HistogramC from '../HistogramC';

class JHSettings extends Component {
    showMessageDialog = (title, content) => {
        const {dispatch} = this.props

        dispatch(showDialog(title, content))
    }

    render() {
        const { isAdmin, isJHAdmin } = this.props

        return (
            <Fragment>
                {(isAdmin || isJHAdmin)?
                    <div className="pageMainContainer">
                        <PersonalJourneyExplainations showMessageDialog={this.showMessageDialog}/>
                    </div>
                :<HistogramC histogramType={'main'} />}
            </Fragment>
        )
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo } = state.authUser;

    const isAdmin = (userInfo && userInfo.isAdmin)
    const isJHAdmin = (userInfo && userInfo.isJHAdmin)

    return {
        isAuthed, isAdmin, isJHAdmin
    }
}

export default connect(mapStateToProps)(JHSettings)